import {
  Button,
  CircularProgress,
  Dialog,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Popover,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { postApiCall } from 'api/apiService';
import ContactPopOver from 'component/ContactTab/ContactPopOver';
import Timerstatus from 'component/LiveOfferStatus/Timerstatus';
import { UPDATE_START_TIME } from 'constant/app.config';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { pick_date } from 'component/PropertyCreation/PropertyCreation.style';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import { poppins400, poppins500 } from 'theme/common.style';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import {
  Pendingwarning,
  Warning,
} from 'component/BuyersMarketplace/Marketplaceicons';
import moment from 'moment';
import Loading from 'assets/images/loading.png';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

const SettingsIconSvg = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9838 0.943954C12.0711 1.11327 12.0928 1.33011 12.1361 1.76378C12.2182 2.58465 12.2593 2.99508 12.4311 3.22027C12.649 3.50592 13.0034 3.65272 13.3595 3.60482C13.6402 3.56706 13.9594 3.30586 14.5979 2.78347C14.9352 2.50749 15.1038 2.3695 15.2853 2.31153C15.5158 2.23789 15.7652 2.25033 15.9872 2.34653C16.162 2.42228 16.3161 2.57637 16.6243 2.88454L17.5178 3.77801C17.8259 4.08619 17.98 4.24029 18.0558 4.4151C18.152 4.63712 18.1644 4.88649 18.0908 5.11699C18.0328 5.29847 17.8948 5.46713 17.6188 5.80445C17.0964 6.44294 16.8352 6.76219 16.7975 7.0429C16.7496 7.39897 16.8964 7.75336 17.182 7.97127C17.4072 8.14306 17.8176 8.18411 18.6385 8.2662C19.0722 8.30957 19.2891 8.33125 19.4584 8.41859C19.6734 8.5295 19.841 8.71463 19.9299 8.93964C20 9.11681 20 9.33474 20 9.77059V11.0342C20 11.47 20 11.6878 19.93 11.865C19.841 12.09 19.6734 12.2752 19.4583 12.3861C19.289 12.4734 19.0722 12.4951 18.6386 12.5385L18.6386 12.5385C17.818 12.6205 17.4077 12.6616 17.1825 12.8333C16.8967 13.0512 16.7499 13.4058 16.7979 13.762C16.8357 14.0425 17.0968 14.3617 17.619 14.9999C17.8949 15.3371 18.0328 15.5057 18.0908 15.6871C18.1645 15.9177 18.152 16.1672 18.0558 16.3893C17.98 16.564 17.826 16.718 17.5179 17.0261L16.6243 17.9197C16.3162 18.2279 16.1621 18.382 15.9873 18.4577C15.7652 18.5539 15.5159 18.5664 15.2854 18.4927C15.1039 18.4347 14.9352 18.2968 14.5979 18.0208L14.5979 18.0208C13.9594 17.4984 13.6402 17.2372 13.3595 17.1994C13.0034 17.1515 12.649 17.2983 12.4311 17.584C12.2593 17.8092 12.2183 18.2197 12.1362 19.0407C12.0928 19.4745 12.0711 19.6915 11.9837 19.8608C11.8728 20.0758 11.6877 20.2433 11.4628 20.3323C11.2856 20.4023 11.0676 20.4023 10.6316 20.4023H9.36824C8.93239 20.4023 8.71447 20.4023 8.53729 20.3323C8.31228 20.2433 8.12716 20.0758 8.01624 19.8607C7.92891 19.6914 7.90722 19.4746 7.86385 19.0409C7.78176 18.22 7.74072 17.8095 7.56892 17.5843C7.35101 17.2987 6.99663 17.1519 6.64057 17.1998C6.35985 17.2376 6.04059 17.4988 5.40208 18.0212L5.40206 18.0212C5.06473 18.2972 4.89607 18.4352 4.71458 18.4932C4.4841 18.5668 4.23474 18.5544 4.01272 18.4582C3.8379 18.3824 3.6838 18.2283 3.37561 17.9201L2.48217 17.0267C2.17398 16.7185 2.01988 16.5644 1.94414 16.3896C1.84794 16.1676 1.8355 15.9182 1.90913 15.6877C1.96711 15.5062 2.10511 15.3376 2.3811 15.0002C2.90351 14.3617 3.16471 14.0425 3.20247 13.7618C3.25037 13.4057 3.10357 13.0513 2.81792 12.8334C2.59273 12.6616 2.1823 12.6206 1.36143 12.5385C0.927764 12.4951 0.71093 12.4734 0.541612 12.3861C0.326558 12.2752 0.159016 12.0901 0.0700471 11.865C0 11.6879 0 11.47 0 11.0341V9.77069C0 9.33474 0 9.11677 0.0700841 8.93956C0.15905 8.71461 0.326541 8.52953 0.541523 8.41862C0.710878 8.33126 0.927769 8.30957 1.36155 8.26619H1.36155H1.36156C2.18264 8.18408 2.59319 8.14302 2.81842 7.97115C3.10395 7.75326 3.2507 7.39898 3.20287 7.04301C3.16514 6.76221 2.90385 6.44286 2.38128 5.80416C2.10516 5.46669 1.96711 5.29796 1.90914 5.1164C1.83557 4.88599 1.848 4.63672 1.94413 4.41478C2.01988 4.23989 2.17403 4.08573 2.48233 3.77743L3.37565 2.88411L3.37566 2.88411C3.68385 2.57591 3.83795 2.42182 4.01277 2.34607C4.23478 2.24988 4.48414 2.23744 4.71463 2.31107C4.89612 2.36904 5.06481 2.50706 5.4022 2.78311C6.04061 3.30545 6.35982 3.56662 6.64044 3.60441C6.99661 3.65238 7.35113 3.50553 7.56907 3.21976C7.74077 2.99461 7.78181 2.58429 7.86387 1.76365C7.90722 1.3301 7.9289 1.11333 8.01619 0.944048C8.12712 0.728919 8.31231 0.561324 8.53741 0.472353C8.71453 0.402344 8.93238 0.402344 9.3681 0.402344H10.6318C11.0676 0.402344 11.2855 0.402344 11.4627 0.472392C11.6877 0.56136 11.8728 0.728901 11.9838 0.943954ZM10 14.4023C12.2091 14.4023 14 12.6115 14 10.4023C14 8.1932 12.2091 6.40234 10 6.40234C7.79086 6.40234 6 8.1932 6 10.4023C6 12.6115 7.79086 14.4023 10 14.4023Z"
        fill="#9F9F9F"
      />
    </svg>
  );
};
const Timeicon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.51496 1.01896C8.34401 1.00635 8.17225 1 8 1V0C8.19685 0 8.39314 0.00726199 8.58852 0.0216722L8.51496 1.01896ZM10.5193 1.46905C10.1985 1.34533 9.86912 1.2454 9.53371 1.17008L9.75282 0.194382C10.1361 0.280463 10.5126 0.394665 10.8792 0.536055L10.5193 1.46905ZM11.889 2.17971C11.7458 2.08402 11.5994 1.99388 11.4503 1.90939L11.9432 1.0393C12.1136 1.13586 12.2809 1.23888 12.4446 1.34824C12.6082 1.4576 12.7674 1.5727 12.9219 1.69322L12.3066 2.48158C12.1715 2.37612 12.0322 2.27541 11.889 2.17971ZM13.7231 3.96934C13.5252 3.68829 13.3068 3.42218 13.0697 3.17321L13.794 2.48368C14.0649 2.76821 14.3145 3.07233 14.5407 3.39353L13.7231 3.96934ZM14.4672 5.32122C14.4012 5.16208 14.3296 5.00583 14.2526 4.85271L15.1458 4.40311C15.2339 4.5781 15.3157 4.75667 15.391 4.93853C15.4664 5.12039 15.5348 5.30453 15.5962 5.49054L14.6467 5.80423C14.5929 5.64147 14.5331 5.48035 14.4672 5.32122ZM14.9979 7.82822C14.9895 7.48455 14.9557 7.14197 14.8969 6.80326L15.8822 6.63231C15.9494 7.01939 15.988 7.41092 15.9976 7.80367L14.9979 7.82822ZM14.8655 9.36563C14.8991 9.1967 14.9264 9.02699 14.9474 8.85687L15.9398 8.97929C15.9159 9.17372 15.8847 9.36766 15.8463 9.56072C15.8079 9.75378 15.7625 9.94489 15.7102 10.1337L14.7464 9.867C14.7922 9.70179 14.8319 9.53457 14.8655 9.36563ZM13.914 11.745C14.0979 11.4546 14.2602 11.151 14.3995 10.8367L15.3137 11.2419C15.1545 11.6011 14.969 11.9481 14.7588 12.28L13.914 11.745ZM12.9497 12.9497C13.0715 12.828 13.1885 12.702 13.3005 12.5722L14.0577 13.2254C13.9297 13.3737 13.796 13.5177 13.6569 13.6569L12.9497 12.9497Z"
        fill="#212529"
      />
      <path
        d="M8 1C6.84885 1 5.71545 1.2839 4.70022 1.82655C3.68499 2.3692 2.81926 3.15386 2.17971 4.11101C1.54017 5.06816 1.14654 6.16827 1.03371 7.31388C0.920876 8.45949 1.09232 9.61525 1.53285 10.6788C1.97337 11.7423 2.66939 12.6808 3.55925 13.4111C4.44911 14.1414 5.50533 14.6409 6.63437 14.8655C7.76341 15.0901 8.93041 15.0327 10.032 14.6986C11.1336 14.3644 12.1358 13.7637 12.9497 12.9497L13.6569 13.6569C12.7266 14.5871 11.5812 15.2736 10.3223 15.6555C9.06332 16.0374 7.72961 16.1029 6.43928 15.8463C5.14895 15.5896 3.94183 15.0187 2.92486 14.1841C1.90788 13.3495 1.11243 12.2769 0.608966 11.0615C0.105504 9.846 -0.0904279 8.52514 0.0385242 7.21586C0.167476 5.90659 0.617333 4.64933 1.34825 3.55544C2.07916 2.46155 3.06857 1.5648 4.22883 0.94463C5.38909 0.324457 6.68439 0 8 0V1Z"
        fill="#212529"
      />
      <path
        d="M7.5 3C7.77614 3 8 3.22386 8 3.5V8.70984L11.2481 10.5659C11.4878 10.7029 11.5711 11.0083 11.4341 11.2481C11.2971 11.4878 10.9917 11.5711 10.7519 11.4341L7.25193 9.43412C7.09615 9.3451 7 9.17943 7 9V3.5C7 3.22386 7.22386 3 7.5 3Z"
        fill="#212529"
      />
    </svg>
  );
};
const Dateicon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2V5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 2V5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 9.08984H20.5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6937 13.6992H15.7027"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6937 16.6992H15.7027"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9945 13.6992H12.0035"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9945 16.6992H12.0035"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.29529 13.6992H8.30427"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.29529 16.6992H8.30427"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

function PropertySettingAction(props) {
  const {
    inActive,
    propertyData,
    publishcard,
    unpublishcard,
    activityfun,
    isUnPublished,
  } = props;
  const [openBox, setOpenBox] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [actionValue, setActionValue] = React.useState('');
  const [timerLoading, setTimerLoading] = React.useState(false);

  const [unPublishPauseTimer, setUnPublishPauseTimer] = useState(false);

  const handleOpenPause = () => {
    setUnPublishPauseTimer(true);
    setAnchorEl(null);
  };
  const UserType = JSON.parse(localStorage.getItem('primaryUser'));
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const handleEditOpen = () => {
    setOpenEditDialog(true);
    setAnchorEl(null);
  };

  const [startDate, setStartdate] = useState('');
  const [starttime, setStarttime] = useState('');
  const [enddate, setEnddate] = useState('');
  const [endtime, setEndtime] = useState('');

  // const isToday = startDate && dayjs(startDate).isSame(dayjs(), 'day');

  const [errorMessageStartDate, setErrorMessageStartDate] = useState(false);
  const [errorMessageEndingDate, setErrorMessageEndingDate] = useState(false);
  const [errorMessageEndTime, setErrorMessageEndTime] = useState(false);
  const [errorMessageStartTime, setErrorMessageStartTime] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [initialTimer, setInitialTimer] = useState({});
  useEffect(() => {
    const start = dayjs(propertyData?.startedAt);
    const end = dayjs(propertyData?.endedAt);

    setStartdate(start);
    setStarttime(start);
    setEnddate(end);
    setEndtime(end);

    setInitialTimer({
      startDate: start.format('YYYY-MM-DD'),
      startTime: start.format('HH:mm:ss'),
      endDate: end.format('YYYY-MM-DD'),
      endTime: end.format('HH:mm:ss'),
    });

    setIsInitialLoad(true);

    setErrorMessageStartDate(false);
    setErrorMessageStartTime(false);
    setErrorMessageEndingDate(false);
    setErrorMessageEndTime(false);
  }, [openEditDialog]);

  const isTimerChanged = () => {
    if (!initialTimer.startDate) return false;

    return (
      dayjs(startDate).format('YYYY-MM-DD') !== initialTimer.startDate ||
      dayjs(starttime).format('HH:mm:ss') !== initialTimer.startTime ||
      dayjs(enddate).format('YYYY-MM-DD') !== initialTimer.endDate ||
      dayjs(endtime).format('HH:mm:ss') !== initialTimer.endTime
    );
  };
  useEffect(() => {
    if (openEditDialog) {
      const timer = setTimeout(() => {
        setIsInitialLoad(false);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [openEditDialog]);

  const sydneyNow = dayjs().tz('Australia/Sydney');

  const isPastDateTime = (date, time) => {
    if (!date || !time) return false;

    const selectedDateTime = dayjs(date)
      .hour(dayjs(time).hour())
      .minute(dayjs(time).minute())
      .second(0);

    return selectedDateTime.isBefore(sydneyNow);
  };

  const isStartDateTimePast = isPastDateTime(startDate, starttime);
  const isEndDateTimePast = isPastDateTime(enddate, endtime);

  const isEndDateBeforeStart = () => {
    if (!startDate || !enddate) return false;
    return dayjs(enddate).isBefore(dayjs(startDate), 'day');
  };

  const isEndTimeBeforeStart = () => {
    if (!startDate || !enddate || !starttime || !endtime) return false;

    if (!dayjs(enddate).isSame(dayjs(startDate), 'day')) return false;

    const startDateTime = dayjs(startDate)
      .hour(dayjs(starttime).hour())
      .minute(dayjs(starttime).minute());

    const endDateTime = dayjs(enddate)
      .hour(dayjs(endtime).hour())
      .minute(dayjs(endtime).minute());

    return endDateTime.isBefore(startDateTime);
  };

  const getMinEndDate = () => {
    if (startDate) {
      return dayjs(startDate);
    }
    return dayjs();
  };

  const isTodaySydney =
    startDate && dayjs(startDate).isSame(sydneyNow.format('YYYY-MM-DD'), 'day');

  const isEndTodaySydney =
    enddate && dayjs(enddate).isSame(sydneyNow.format('YYYY-MM-DD'), 'day');

  const isEndTimeBeforeNow = (() => {
    if (!isEndTodaySydney || !endtime) return false;

    const nowSydney = dayjs().tz('Australia/Sydney');

    const currentMinutes = nowSydney.hour() * 60 + nowSydney.minute();

    const selectedMinutes = endtime.hour() * 60 + endtime.minute();

    return selectedMinutes < currentMinutes;
  })();

  const isStartTimeBeforeNow = (() => {
    if (!isTodaySydney || !starttime) return false;

    const nowSydney = dayjs().tz('Australia/Sydney');

    const currentMinutes = nowSydney.hour() * 60 + nowSydney.minute();

    // starttime may be moment OR dayjs → both support hour() & minute()
    const selectedMinutes = starttime.hour() * 60 + starttime.minute();

    return selectedMinutes < currentMinutes;
  })();

  const handleOpenConfirmModal = () => {
    if (startDate === '') {
      setErrorMessageStartDate(true);
      return;
    } else {
      setErrorMessageStartDate(false);
    }

    if (starttime === '') {
      setErrorMessageStartTime(true);
      return;
    } else {
      setErrorMessageStartTime(false);
    }

    if (enddate === '') {
      setErrorMessageEndingDate(true);
      return;
    } else {
      setErrorMessageEndingDate(false);
    }

    if (endtime === '') {
      setErrorMessageEndTime(true);
      return;
    } else {
      setErrorMessageEndTime(false);
    }

    if (!isInitialLoad) {
      if (isStartDateTimePast) {
        setErrorMessageStartDate(true);
        setErrorMessageStartTime(true);
        return;
      }

      if (isEndDateTimePast) {
        setErrorMessageEndingDate(true);
        setErrorMessageEndTime(true);
        return;
      }
    }

    if (isEndDateBeforeStart()) {
      setErrorMessageEndingDate(true);
      return;
    }

    if (isEndTimeBeforeStart()) {
      setErrorMessageEndTime(true);
      return;
    }

    EditCampaignTimer();
  };

  const isConfirmDisabled =
    !isTimerChanged() ||
    (!isInitialLoad && (isStartDateTimePast || isEndDateTimePast)) ||
    isEndDateBeforeStart() ||
    isEndTimeBeforeStart() ||
    errorMessageStartDate ||
    errorMessageStartTime ||
    errorMessageEndingDate ||
    errorMessageEndTime;

  const resetForm = () => {
    setStartdate('');
    setStarttime('');
    setEnddate('');
    setEndtime('');
    setUnPublishPauseTimer(false);
    setOpenEditDialog(false);
    setEditLoading(false);
  };

  const showAlert = (type, res) => {
    Swal.fire({
      title: res?.data?.heading || (type === 'success' ? 'Success' : 'Error'),
      text: res?.data?.message,
      icon: type,
      confirmButtonText: 'Close',
    });
  };

  const EditCampaignTimer = async () => {
    setEditLoading(true);
    try {
      const propertyId = propertyData?.property?.propertyId;

      const params = {
        propertyId,
        campaignStart: dayjs(startDate).format('YYYY-MM-DD'),
        campaignStartTime: dayjs(starttime).format('HH:mm:ss'),
        campaignEnd: dayjs(enddate).format('YYYY-MM-DD'),
        campaignEndTime: dayjs(endtime).format('HH:mm:ss'),
      };

      const pausedInput = {
        propertyId,
        isPaused: 1,
      };

      const res = await postApiCall(
        UPDATE_START_TIME,
        unPublishPauseTimer ? pausedInput : params
      );

      if (res?.data?.status === 1) {
        showAlert('success', res);
      } else {
        showAlert('error', res);
      }
    } catch (err) {
      Swal.fire({
        title: 'Error',
        text: 'Something went wrong',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      resetForm(); // ✅ single place cleanup
    }
  };
  const handleClicke = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosee = () => {
    setAnchorEl(null);
  };

  const openn = Boolean(anchorEl);
  const id = openn ? 'simple-popover' : undefined;

  const params = useParams();
  const history = useHistory();

  const onPropertyClick = () => {
    let propertyId = params?.dashboardId;
    history.push({
      pathname: inActive
        ? `dashboard/viewinactive-dashboard/${propertyData?.property?.propertyId}`
        : `/dashboard/view-dashboard/${propertyData?.property?.propertyId}`,
    });
    window.scrollTo(0, 0);
  };

  const onPropertyClickStage2 = async () => {
    await localStorage.setItem('cardSt2', ' ');
    let propertyId = params?.dashboardId;
    history.push({
      pathname: inActive
        ? `dashboard/viewinactive-dashboard/${propertyData?.property?.propertyId}`
        : `/dashboard/view-dashboard/${propertyData?.property?.propertyId}`,
      state: {
        dashboardCommenceStage2: true,
      },
    });
    window.scrollTo(0, 0);
  };

  const valueFunc = (val) => {
    setOpenBox(true);
    setActionValue(val);
    handleClosee();
  };

  return (
    <>
      <Grid>
        <Typography aria-describedby={id} onClick={handleClicke}>
          <IconButton>
            <SettingsIconSvg />
          </IconButton>
        </Typography>
        <Popover
          id={id}
          open={openn}
          anchorEl={anchorEl}
          onClose={handleClosee}
          PaperProps={{
            style: { boxShadow: 'none', border: '1px solid #D9D9D9' },
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {propertyData?.timerStatus == 'Pause' && (
            <MenuItem
              disabled={propertyData?.timerStatus == 'End'}
              value={actionValue}
              onClick={() => {
                valueFunc('Start');
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2F3F5E',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                }}
              >
                Resume
              </Typography>
            </MenuItem>
          )}

          {propertyData?.timerStatus == 'End' && (
            <MenuItem
              disabled={propertyData?.timerStatus == 'End'}
              value={actionValue}
              onClick={() => {
                valueFunc('Pause');
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2F3F5E',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                }}
              >
                Pause
              </Typography>
            </MenuItem>
          )}
          {propertyData?.timerStatus == 'Start' && (
            <MenuItem
              disabled={propertyData?.timerStatus == 'End'}
              value={actionValue}
              onClick={() => {
                valueFunc('Pause');
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2F3F5E',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                }}
              >
                Pause
              </Typography>
            </MenuItem>
          )}

          {/* {propertyData?.timerStatus !== "End" && propertyData?.property?.status == "Publish" && ( */}
          {propertyData?.property?.status == 'Publish' && (
            <MenuItem
              value={20}
              onClick={() => {
                valueFunc('End');
              }}
              disabled={propertyData?.timerStatus == 'End'}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2F3F5E',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                }}
              >
                End
              </Typography>
            </MenuItem>
          )}

          {propertyData?.property?.status == 'Publish' && (
            <MenuItem
              value={20}
              disabled={
                (propertyData?.isApprovedLog != 1 &&
                  propertyData?.stage == 'ST1') ||
                propertyData?.stage == 'ST2' ||
                (propertyData?.stage == 'ST1' && propertyData?.isWinner == 1)
              }
              onClick={onPropertyClickStage2}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2F3F5E',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                }}
              >
                Commence Stage 2
              </Typography>
            </MenuItem>
          )}

          {UserType == 'Agent' && isUnPublished && (
            <MenuItem
              value={62}
              onClick={() => {
                handleEditOpen();
              }}
              sx={{ minHeight: matchessm ? '0px' : '' }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2F3F5E',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                }}
              >
                Edit
              </Typography>
            </MenuItem>
          )}
          {/* {UserType == 'Agent' && isUnPublished && (
            <MenuItem
              disabled={propertyData?.timerDuration == 0}
              onClick={() => {
                handleOpenPause();
              }}
              value={62}
              sx={{ minHeight: matchessm ? '0px' : '' }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#2F3F5E',
                  lineHeight: 'normal',
                  fontStyle: 'normal',
                }}
              >
                Pause
              </Typography>
            </MenuItem>
          )} */}

          {/* Call Vendor Menu*/}
          <CallVendor propertyData={propertyData} handleClosee={handleClosee} />

          <MenuItem value={20} onClick={onPropertyClick}>
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 400,
                fontSize: '12px',
                color: '#2F3F5E',
                lineHeight: 'normal',
                fontStyle: 'normal',
              }}
            >
              Campaign settings
            </Typography>
          </MenuItem>
        </Popover>
      </Grid>

      {openBox && (
        <Timerstatus
          openBox={openBox}
          setOpenBox={setOpenBox}
          profileDetails={propertyData}
          actionValue={actionValue}
          dashboard={true}
          publishcard={publishcard}
          unpublishcard={unpublishcard}
          activityfun={activityfun}
        />
      )}

      <Dialog
        open={openEditDialog}
        // onClose={() => setOpenEditDialog(!openEditDialog)}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            // height: matchessm ? "350px" : "300px",/
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {propertyData?.propertyAddress?.streetName}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Warning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Countdown Timer
            </Typography>
          </Grid>

          <Grid
            item
            xs={matchessm ? 6 : 4.5}
            textAlign={'left'}
            marginLeft={matchessm ? '0' : '55px'}
            minWidth={matchessm ? '100%' : '0'}
          >
            <Grid
              sx={{
                display: 'flex',
                gap: matchessm ? '8px' : '20px',
                flexDirection: matchessm ? 'column' : 'row',
              }}
            >
              <Grid item>
                <FormLabel
                  sx={{
                    color: '#666666',
                    fontSize: matchessm ? '12px' : '17px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                  }}
                >
                  Start Date
                </FormLabel>
                <div style={{ marginTop: '5px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        sx={{
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0, 85, 255, 0.64)',
                          },
                        }}
                        inputProps={{
                          style: { fontFamily: 'Poppins' },
                          required: true,
                        }}
                        minDate={!isInitialLoad ? dayjs() : undefined}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: errorMessageStartDate,
                            helperText: errorMessageStartDate
                              ? 'Select start date'
                              : null,
                          },
                        }}
                        format="DD-MM-YYYY"
                        value={
                          startDate ? dayjs(startDate, 'YYYY-MM-DD') : null
                        }
                        onChange={(newValue) => {
                          let val = newValue.format('YYYY-MM-DD');
                          setStartdate(val);
                          if (!isInitialLoad) {
                            const isPast = dayjs(val).isBefore(
                              sydneyNow,
                              'day'
                            );
                            setErrorMessageStartDate(isPast);
                          }
                        }}
                        slots={{ openPickerIcon: Dateicon }}
                        ampm={false}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </Grid>

              <Grid item>
                <FormLabel
                  sx={{
                    color: '#666666',
                    fontSize: matchessm ? '12px' : '17px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                  }}
                >
                  Start Time
                </FormLabel>
                <div style={{ marginTop: '5px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker', 'TimePicker']}>
                      <TimePicker
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: errorMessageStartTime,
                            helperText: errorMessageStartTime
                              ? 'Select start time'
                              : null,
                          },
                        }}
                        fullWidth
                        sx={{
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0, 85, 255, 0.64)',
                          },
                        }}
                        views={['hours', 'minutes']}
                        value={starttime ? dayjs(starttime) : null}
                        minTime={
                          !isInitialLoad && isTodaySydney ? sydneyNow : null
                        }
                        onChange={(newValue) => {
                          setStarttime(newValue);

                          if (!isInitialLoad && isTodaySydney && newValue) {
                            const selectedMinutes =
                              newValue.hour() * 60 + newValue.minute();
                            const currentMinutes =
                              sydneyNow.hour() * 60 + sydneyNow.minute();
                            setErrorMessageStartTime(
                              selectedMinutes < currentMinutes
                            );
                          } else {
                            setErrorMessageStartTime(false);
                          }

                          if (isEndTimeBeforeStart()) {
                            setErrorMessageEndTime(true);
                          }
                        }}
                        slots={{ openPickerIcon: Timeicon }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {/* {errorMessageStartTime && (
                        <div>{errorMessageStartTime}</div>
                        )} */}
              </Grid>
            </Grid>
            <Grid
              sx={{
                display: 'flex',
                gap: matchessm ? '8px' : '20px',
                marginTop: matchessm ? '15px' : '25px',
                flexDirection: matchessm ? 'column' : 'row',
              }}
            >
              <Grid item>
                <FormLabel
                  sx={{
                    color: '#666666',
                    fontSize: matchessm ? '12px' : '17px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                  }}
                >
                  End Date
                </FormLabel>
                <div style={{ marginTop: '5px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        required
                        sx={{
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0, 85, 255, 0.64)',
                          },
                        }}
                        minDate={getMinEndDate()}
                        format="DD-MM-YYYY"
                        value={enddate ? dayjs(enddate, 'YYYY-MM-DD') : null}
                        onChange={(newValue) => {
                          let val = newValue.format('YYYY-MM-DD');
                          setEnddate(val);

                          if (
                            startDate &&
                            dayjs(val).isBefore(dayjs(startDate), 'day')
                          ) {
                            setErrorMessageEndingDate(true);
                          } else {
                            setErrorMessageEndingDate(false);
                          }

                          setErrorMessageEndTime(false);
                        }}
                        slots={{ openPickerIcon: Dateicon }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: errorMessageEndingDate,
                            helperText: errorMessageEndingDate
                              ? 'End date must be after start date'
                              : null,
                          },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {/* {errorMessageEndingDate && (
                        <div>{errorMessageEndingDate}</div>
                        )} */}
              </Grid>

              <Grid item>
                <FormLabel
                  sx={{
                    color: '#666666',
                    fontSize: matchessm ? '12px' : '17px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                  }}
                >
                  End Time
                </FormLabel>
                <div style={{ marginTop: '5px' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker', 'TimePicker']}>
                      <TimePicker
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: errorMessageEndTime,
                            helperText: errorMessageEndTime
                              ? 'End time must be after start time'
                              : isEndDateTimePast && !isInitialLoad
                              ? 'End time cannot be in the past'
                              : null,
                          },
                        }}
                        fullWidth
                        sx={{
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0, 85, 255, 0.64)',
                          },
                        }}
                        views={['hours', 'minutes']}
                        value={endtime ? dayjs(endtime) : null}
                        minTime={
                          !isInitialLoad && isEndTodaySydney ? sydneyNow : null
                        }
                        onChange={(newValue) => {
                          setEndtime(newValue);

                          if (startDate && enddate && starttime && newValue) {
                            const sameDay = dayjs(enddate).isSame(
                              dayjs(startDate),
                              'day'
                            );

                            if (sameDay) {
                              const startDateTime = dayjs(startDate)
                                .hour(dayjs(starttime).hour())
                                .minute(dayjs(starttime).minute());

                              const endDateTime = dayjs(enddate)
                                .hour(newValue.hour())
                                .minute(newValue.minute());

                              setErrorMessageEndTime(
                                endDateTime.isBefore(startDateTime)
                              );
                            } else {
                              setErrorMessageEndTime(false);
                            }
                          }

                          if (!isInitialLoad && isEndTodaySydney && newValue) {
                            const selectedMinutes =
                              newValue.hour() * 60 + newValue.minute();
                            const currentMinutes =
                              sydneyNow.hour() * 60 + sydneyNow.minute();

                            if (selectedMinutes < currentMinutes) {
                              setErrorMessageEndTime(true);
                            }
                          }
                        }}
                        slots={{ openPickerIcon: Timeicon }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                {/* {errorMessageEndTime && <div>{errorMessageEndTime}</div>} */}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={matchessm ? '8px' : 2}
            marginTop={matchessm ? 2 : 4}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => {
                  setErrorMessageStartDate('');
                  setErrorMessageEndingDate('');
                  setErrorMessageEndTime('');
                  setErrorMessageStartTime('');
                  setOpenEditDialog(!openEditDialog);
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={isConfirmDisabled}
                onClick={() => {
                  handleOpenConfirmModal();
                }}
                variant="outlined"
                sx={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: '#4CA4D6' },
                  '&.Mui-disabled': {
                    backgroundColor: '#4CA4D6',
                    color: '#fff',
                    opacity: 0.7,
                    cursor: 'not-allowed',
                    pointerEvents: 'auto',
                  },
                }}
                // disabled={loading}
              >
                Confirm
              </Button>
              {editLoading && (
                <img
                  alt="Loader"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={unPublishPauseTimer}
        fullWidth={'lg'}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {propertyData?.propertyAddress?.streetName}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Pause Campaign
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                marginTop: '50px',
              }}
            >
              Would you like to Pause the Campaign now?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                onClick={() => {
                  setUnPublishPauseTimer(false);
                }}
                variant="outlined"
                disabled={editLoading}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <Button
                onClick={() => {
                  EditCampaignTimer();
                }}
                variant="outlined"
                disabled={editLoading}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  minWidth: '140px',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Confirm
              </Button>
              {editLoading && (
                <img
                  alt="Loader"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}

const CallVendor = ({ propertyData, handleClosee }) => {
  const [anchorEll, setAnchorEll] = React.useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleClick = (mobilenum) => {
    // setAnchorEll(event.currentTarget);
    // setDialogOpen(true);
    return window.open(`tel:` + mobilenum);
  };
  const callVendorClose = () => {
    setAnchorEll(null);
    setDialogOpen(false);
    handleClosee();
  };

  return (
    <>
      <MenuItem
        onClick={() => {
          handleClick(propertyData?.propertyOwnerDetails[0]?.userMobile);
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins!important',
            fontWeight: 400,
            fontSize: '12px',
            color: '#2F3F5E',
            lineHeight: 'normal',
            fontStyle: 'normal',
          }}
        >
          Call Vendor
        </Typography>
      </MenuItem>
      <ContactPopOver
        name={propertyData?.propertyOwnerDetails[0]?.user?.userName}
        surname={propertyData?.propertyOwnerDetails[0]?.user?.userSurName}
        emailid={propertyData?.propertyOwnerDetails[0]?.userEmail}
        mobilenum={propertyData?.propertyOwnerDetails[0]?.userMobile}
        isDialogOpen={isDialogOpen}
        setDialogOpen={setDialogOpen}
        anchorEl={anchorEll}
        setAnchorEl={setAnchorEll}
      />
    </>
  );
};

export default PropertySettingAction;
